module.exports = function($) {
    class LigthBox {

        constructor(c) {
            this.class = c;
            this.images = [];
            this.titles = [];
            this.init();
            this.bind();
            this.index = 0;
        }

        init() {
            let _this = this;
            $(this.class).each(function () {
                $(this).css({'cursor': 'pointer'});
                _this.images.push( $(this).attr('src') );
                _this.titles.push( $(this).attr('data-title') );
            })

        }

        bind() {
            let _this = this;
            $('body').on('click', this.class, function () {
                let src = $(this).attr('src');
                _this.index = _this.images.indexOf(src);
                _this.construct();
            })
            $('body').on('click', '.wrapper-LigthBox .LigthBox-close', this.class, function () {
                _this.destroy();
            })
            $('body').on('click', '.wrapper-LigthBox .next', this.class, function () {
                _this.next();
            })
            $('body').on('click', '.wrapper-LigthBox .prev', this.class, function () {
                _this.prev();
            })
            $('body').on('click', '.wrapper-LigthBox .images img', this.class, function () {
                _this.next();
            })
        }

        next(){
            if( this.index < this.images.length - 1 ){
                this.index += 1;
                let child = this.index + 1;
                $(".wrapper-LigthBox .images .image").css({"display": "none"});
                $(".wrapper-LigthBox .images .image:nth-child("+child+")").css({"display": "block"});
            }
        }

        prev(){
            if( this.index > 0 ){
                this.index -= 1;
                let child = this.index + 1;
                $(".wrapper-LigthBox .images .image").css({"display": "none"});
                $(".wrapper-LigthBox .images .image:nth-child("+child+")").css({"display": "block"});
            }
        }

        destroy(){
            $('.wrapper-LigthBox').remove();
        }

        construct(){
            if($('.wrapper-LigthBox').length == 1){
                this.destroy();
            }
            let html = "";

            for( let i in this.images){
                let display = 'none';
                let title = "";
                if( typeof (this.titles[i]) != "undefined" ){
                    title = this.titles[i];
                }
                if( i == this.index ){
                    display = "block";
                }
                html += "<div class='image' style='display:"+display+"'><img src='"+this.images[i]+"'><div class='title'>"+title+"</div></div>";
            }
            html =
                "<div class='wrapper-LigthBox'>" +
                "<button class='LigthBox-close btn-close'><i class='icon close'></i></button>" +
                "<div class='images'>" +
                    html +
                    "<div class='nav-prev'><i class='icon prev'></i></div>" +
                    "<div class='nav-next'><i class='icon next'></i></div>" +
                "</div>" +
                "<div class='layer LigthBox-close'></div>" +
                "</div>";
            $('body').append(html)
        }
    }

    new LigthBox('.LigthBox');
}
